import type {
  // ClusterJsonldReadCollectionAgency,
  // ClusterJsonldReadCollectionCollaborator,
  // ClusterJsonldReadCollectionPeople,
  // ClusterJsonldReadCollectionProject,
  ClusterJsonldReadItemAgencyItem,
  ClusterJsonldReadItemCollaboratorItem,
  ClusterJsonldReadItemPeople,
  ClusterJsonldReadItemProject,
} from "@/networking/api"
import type { LocalRefLabel } from "@/utils/i18n/t11n"

export type RelatedClusterProperties = {
  function?: string | null
  role?: LocalRefLabel | null
  rank?: LocalRefLabel | null
  isPublished?: boolean | null
  isPublishedInDirectory?: boolean | null
  isDefault?: boolean | null
  dateOfEntry?: string
  dateOfLeaving?: string | null
  metadatas?: { [k: string]: string }
  status?: LocalRefLabel | null
}
export type RelatedCluster =
  // | ClusterJsonldReadCollectionAgency
  // | ClusterJsonldReadCollectionCollaborator
  // | ClusterJsonldReadCollectionPeople
  // | ClusterJsonldReadCollectionProject
  (
    | ClusterJsonldReadItemAgencyItem
    | ClusterJsonldReadItemCollaboratorItem
    | ClusterJsonldReadItemProject
    | ClusterJsonldReadItemPeople
  ) &
    RelatedClusterProperties

export type ObjectWithRelatedClusters = {
  [k: string]: unknown
  clusters: RelatedCluster[]
}

/*
export type ClusterRelation =
  | RelAgencyClusterJsonldReadCollectionAgency
  | RelAgencyClusterJsonldReadItemAgencyItem
  | RelCollaboratorClusterJsonldReadCollectionCollaborator
  | RelCollaboratorClusterJsonldReadItemCollaboratorItem
  | ProjectClusterJsonldReadCollectionProject
  | ProjectClusterJsonldReadItemProject
  | RelClusterPeopleJsonldReadCollectionPeople
  | RelClusterPeopleJsonldReadItemPeople
*/

export const CLUSTER_STATUS_GROUP = "cluster:status:"
export const CLUSTER_TYPE_GROUP = "cluster:type:"

export const CLUSTER_PREVIEW_WIDTH = 600
export const CLUSTER_SMALL_PREVIEW_WIDTH = 250

export const CLUSTERS_SORT_COLUMN_DEFAULT = "name"
export const CLUSTERS_SORT_ORDER_DEFAULT = "asc"

export const ClusterTypes = {
  BARNES_SAS: "barnes_sas",
  BARNES_PROVENCE: "barnes_provence",
  BARNES_MONT_BLANC: "barnes_mont_blanc",
  BARNES_RENTALS_IDF: "barnes_rentals_idf",
  DIGITAL: "digital",
  PHYSICAL: "physical",
  EXPERTISE_SERVICE: "expertise_service",
  INTERNAL_SERVICE: "internal_service",
  BUSINESS: "business",
  CLUSTER: "cluster",
  HOSPITALITY: "hospitality",
  NPDS: "npds", // No customers provided by external source
} as const
export type ClusterTypes = (typeof ClusterTypes)[keyof typeof ClusterTypes]

// Cluster types grouping BUs that share their people and InterBU with each other (see api ClusterSharingGroup)
export const CLUSTER_SHARING_GROUP_TYPES: string[] = [
  ClusterTypes.BARNES_SAS,
  ClusterTypes.BARNES_PROVENCE,
  ClusterTypes.BARNES_MONT_BLANC,
  ClusterTypes.BARNES_RENTALS_IDF,
]

export const ClusterStatus = {
  ACTIVE: "active",
  ARCHIVE: "archive",
  DELETED: "deleted",
  STANDBY: "standby",
} as const
export type ClusterStatus = (typeof ClusterStatus)[keyof typeof ClusterStatus]

export const ClusterDisplayMode = {
  CLUSTER: "cluster",
  COLLABORATOR: "collaborator",
  BOTH: "both",
} as const
export type ClusterDisplayMode = (typeof ClusterDisplayMode)[keyof typeof ClusterDisplayMode]
